var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStars45 = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 512 96",
  style: {
    enableBackground: "new 0 0 512 96"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#00b67a}.st2{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
  id: "Trustpilot_ratings_4halfstar-RGB"
}, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-path",
  className: "st0",
  d: "M0 0h96v96H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Half"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#dcdce6"
  },
  d: "M48 0h48v96H48z",
  transform: "translate(416)"
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0 0h48v96H0z",
  transform: "translate(416)"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st2",
  d: "M48 64.7 62.6 61l6.1 18.8L48 64.7zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "m152 64.7 14.6-3.7 6.1 18.8L152 64.7zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM256 64.7l14.6-3.7 6.1 18.8L256 64.7zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM360 64.7l14.6-3.7 6.1 18.8L360 64.7zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM464 64.7l14.6-3.7 6.1 18.8L464 64.7zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15z"
})))));
export default SvgStars45;